<template>
  <div class="player-box">
    <audio ref="player" :preload="options.preload" :controls="options.controls" @ready="hanleReady"
      @timeupdate="handleTimeUpdated" @ended="onEnded" @error="onError" @canplaythrough="hanleCanPlay">
      >
      <template>
        <source :src="audio.url" type="audio/mp3" />
        <source :src="audio.url" type="audio/ogg" />
      </template>
    </audio>

    <div class="custom-controls">
      <div class="play-bar">
        <Button :icon="isPlaying?'ios-pause':'ios-play'" type="default" shape="circle" size="small" :disabled="!canPlay"
          @click="play"></Button>
      </div>
      <div class="slider">
        <Slider ref="progress" v-model="audio.currentTime" @on-change="progressChange" :max="audio.durationMax"
          :tip-format="progressTipFormat" show-tip="never"></Slider>
      </div>
      <div class="time-bar">{{audio.displayTime}}/{{audio.durationTime}}</div>
    </div>
  </div>
</template>

<script>
  const pad = val => {
    val = Math.floor(val);
    if (val < 10) {
      return "0" + val;
    }
    return val + "";
  };
  const timeParse = sec => {
    let min = 0;
    min = Math.floor(sec / 60);
    sec = sec - min * 60;
    return pad(min) + ":" + pad(sec);
  };
  export default {
    name: "AudioPlayer",
    data() {
      return {
        audio: {
          url: "",
          durationMax: 0,
          durationTime: "00:00",
          displayTime: "00:00",
          currentTime: 0
        },
        percent: 0,
        isPlaying: this.playing,
        error: false,
        canPlay: false
      };
    },
    props: {
      options: {
        type: Object,
        default () {
          let audioOptions = {
            autoplay: false,
            controls: false,
            preload: "auto",
            muted: false,
            loop: false
          };
          return audioOptions;
        }
      },
      playing: {
        type: Boolean,
        default: false
      },
      audioUrl: {
        type: String,
        default: ""
      }
    },
    computed: {
      player() {
        return this.$refs.player;
      }
    },
    created() {
      this.audio.url = this.audioUrl;
    },
    mounted() {},
    watch: {
      audioUrl(newVal) {
        this.audio.url = newVal;
        this.player.load();
        //this.handleTimeUpdated();
      }
    },
    methods: {
      // 准备播放
      hanleReady() {
        //console.log("Ready");
      },
      hanleCanPlay() {
        //console.log("CanPlay");
        this.handleTimeUpdated();
        this.canPlay = true;
      },
      // 当前播放的时间
      handleTimeUpdated() {
        if (this.player != undefined) {
          this.audio.durationMax = Math.round(this.player.duration);
          this.audio.currentTime = Math.round(this.player.currentTime);
          this.percent = (this.audio.currentTime / this.audio.durationMax).toFixed(
            7
          );
          this.audio.durationTime = timeParse(this.player.duration || 0);
          this.audio.displayTime = timeParse(this.player.currentTime);
        }
      },
      // 播放结束
      onEnded() {
        this.isPlaying = false;
        this.player.currentTime = 0;
        //this.$emit("update:playing", this.isPlaying);
      },
      // 播放错误
      onError(code) {
        console.log("播放错误");
        console.log(code);
        this.error = true;
      },
      // 进度条被拉动
      progressChange(val) {
        val = Number.isNaN(val) ? 0 : val;
        this.player.currentTime = val;
        this.audio.currentTime = val;
      },
      // 进度条提示控制
      progressTipFormat(val) {
        val = Number.isNaN(val) ? 0 : val;
        return timeParse(val);
      },

      // 播放暂停
      play() {
        this.isPlaying = !this.isPlaying;
        //this.$emit("update:playing", this.isPlaying);
        if (this.player && this.isPlaying) {
          this.player.play();
        } else {
          this.player.pause();
        }
      }
    }
  };
</script>


<style lang="less">
  .player-box {
    position: relative;
    width: 180px;
    overflow: hidden;
    user-select: none;
    border-radius: 30px;
    margin: 5px;
  }

  .custom-controls {
    display: flex;
    background-color: #f1f1f1;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
  }

  .play-bar {
    padding: 0 0 0 5px;
  }

  .slider {
    width: 80px;
    padding: 0 5px 0 10px;
  }

  .time-bar {
    color: #111111;
    font-size: 10px;
  }
</style>


// WEBPACK FOOTER //
// AudioPlayer.vue?45e90856